<template>
    <TableProjectManagemenList></TableProjectManagemenList>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const TableProjectManagemenList = defineAsyncComponent(() =>
    import("../../components/ProjectManagement/ProjectList/Table.vue")
);

export default {
    name: "Project_Management_Project_list",
    components: { TableProjectManagemenList, AuthLayout },
};
</script>
